module.exports = __webpack_public_path__ + "static/media/Proxima-Nova-Semibold.621e9bff.ttf";